import Table from 'react-bootstrap/Table'

import {
  formatCompactCurrency,
  formatInteger,
} from './geographicSalesIntelligenceUtils'

export default function GeographicSalesIntelligenceTopMarkets({ markets }) {
  const rows = Array.isArray(markets) ? markets : []

  if (!rows.length) {
    return (
      <p className="text-muted small mb-0">
        Top markets will appear once complete orders include city and region.
      </p>
    )
  }

  return (
    <Table responsive hover className="geo-markets-table mb-0">
      <thead>
        <tr>
          <th>Market</th>
          <th className="text-end">Buyers</th>
          <th className="text-end">Tickets</th>
          <th className="text-end">Revenue</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.market}>
            <td>{row.market}</td>
            <td className="text-end">{formatInteger(row.buyers)}</td>
            <td className="text-end">{formatInteger(row.tickets)}</td>
            <td className="text-end">{formatCompactCurrency(row.revenue)}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}
